var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('vuescroll',{ref:"scroll",staticClass:"scroll-box",class:{ 'scroll-box--no-space': _vm.noSpace },attrs:{"ops":_vm.scrollOpt}},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }